import React from 'react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

interface AvatarDemoProps {
  src?: string
  alt?: string
  fallback?: string
}

export const AvatarComponent: React.FC<AvatarDemoProps> = ({
  src,
  alt,
  fallback,
}) => {
  return (
    <Avatar data-testid='Avatar'>
      <AvatarImage src={src} alt={alt || 'User'} />
      <AvatarFallback className='bg-accent text-accent-foreground text-md rounded-full flex items-center justify-center'>
        {fallback}
      </AvatarFallback>
    </Avatar>
  )
}
